export function setDocument(state,document) {
    state.document=document;
}

export function setPreloader(state, preloader) {
    state.preloader=preloader;
}


// WEBPACK FOOTER //
// ./src/modules/invoice_detail/mutations.js